// Third party
import React from 'react';

// Components
import ComparisonTopBarBaseMenuItem from './ComparisonTopBarBaseMenuItem';

// Utils
import { FormattedMessage } from '../../../../../utils/i18n';

type Props = {
  onClick: () => void;
  disabled: boolean;
};

const ComparisonTopBarSuitabilityAnalysisMenuItem = ({ onClick, disabled }: Props) => (
  <ComparisonTopBarBaseMenuItem
    onClick={onClick}
    disabled={disabled}
    label={<FormattedMessage id="Comparison.Questionnaire.SuitabilityAnalysis.IconTitle" />}
  />
);

export default ComparisonTopBarSuitabilityAnalysisMenuItem;
